import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04097f78")

_pushScopeId("data-v-04097f78")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_2 = { class: "page_content" }
const _hoisted_3 = { class: "container_user_info" }
const _hoisted_4 = { class: "user_avatar_container" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "single_user_info" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Email", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "single_user_info" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Codice fiscale", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "single_user_info" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Cellulare", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "single_user_info" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Data di nascita", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "single_user_info" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Luogo di nascita", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "single_user_info" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Tipologia utente", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "single_user_info" }, [
  /*#__PURE__*/_createVNode("div", { class: "title" }, "Versione applicazione"),
  /*#__PURE__*/_createVNode("div", { class: "value" }, "2.6")
], -1)
const _hoisted_25 = { class: "profile_actions ion-margin-top" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start",
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_ion_avatar, null, {
                  default: _withId(() => [
                    _createVNode("img", {
                      src: $setup.setImage($setup.user)
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_5, _toDisplayString($setup.user.dipendenti_nome) + " " + _toDisplayString($setup.user.dipendenti_cognome), 1)
              ]),
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, _toDisplayString($setup.user.users_email), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, _toDisplayString($setup.user.dipendenti_codice_fiscale || "-"), 1)
              ]),
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", _hoisted_14, _toDisplayString($setup.user.dipendenti_cellulare || "-"), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, _toDisplayString($setup.dateFormat($setup.user.dipendenti_data_nascita) || "-"), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, _toDisplayString($setup.user.dipendenti_luogo_nascita || "-"), 1)
              ]),
              _createVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("div", _hoisted_23, _toDisplayString($setup.user.users_type_value || "-"), 1)
              ]),
              _hoisted_24
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.updateApp && $setup.updateApp(...args))),
                class: "btn_force_update"
              }, " Forza aggiornamento "),
              _createVNode("div", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.logOut && $setup.logOut(...args))),
                class: "btn_logout"
              }, "Logout")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})